import { FC } from 'react'

import { useQueryApi } from 'peach/data/useQueryApi'

import { R, isNotFoundError } from 'core/helpers'
import { useLoanDrawGet } from 'core/types'

import ModelLink from './ModelLink'

type DrawLinkProps = {
  drawId: string
}

const DrawLink: FC<DrawLinkProps> = ({ drawId }) => {
  const [_, { personId, loanId }] = useQueryApi()
  const { data: draw, isLoading } = useLoanDrawGet({
    personId,
    loanId,
    drawId,
    options: {
      throwOnError: R.isNot(isNotFoundError),
    },
  })

  return <ModelLink id={drawId} isLoading={isLoading} model={draw} />
}

export default DrawLink
